import { useState } from "react";

const useModal = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalMessage, setModalMessage] = useState("");
  const [modalAction, setModalAction] = useState(null);
  const [modalCancelAction, setModalCancelAction] = useState(null);

  const showModal = (message, onConfirm, onCancel) => {
    setModalMessage(message);
    setModalAction(() => onConfirm);
    setModalCancelAction(() => onCancel);
    setIsModalOpen(true);
  };

  const handleModalOk = () => {
    if (modalAction) modalAction();
    setIsModalOpen(false);
  };

  const handleModalCancel = () => {
    if (modalCancelAction) modalCancelAction();
    setIsModalOpen(false);
  };

  return {
    isModalOpen,
    modalMessage,
    showModal,
    handleModalOk,
    handleModalCancel,
  };
};

export default useModal;
